import type { FunctionComponent } from 'react';
import ReactTooltip from 'react-tooltip';
import { currency } from '../../../../utils/currency';
import { titleCase } from '../../../../utils/strings';
import * as styles from './styles.module.scss';

type OrderHeaderProps = {
  isDesktop: boolean;
  saleType: string;
  items: number;
  orderTotal: number;
  shippingAddress: Record<string, unknown>;
  onClickHeader: () => void;
  toggleOpen: () => void;
};

const OrderHeader: FunctionComponent<OrderHeaderProps> = ({
  isDesktop,
  saleType,
  items,
  orderTotal,
  shippingAddress,
  onClickHeader,
  toggleOpen,
}) => {
  const { firstName, lastName, address1, address2, city, state, zipCode } = shippingAddress;
  const shipToTooltip = `<p>${firstName} ${lastName}</p>
  <p>${titleCase(address1)} ${titleCase(address2) || ''}</p>
  <p>${titleCase(city)}, ${state} ${zipCode}</p>`;
  const icon = isDesktop ? 'fal fa-angle-down' : 'fal fa-angle-right';

  return (
    <>
      <div
        className={styles.collapsibleBar}
        onClick={onClickHeader}
        onKeyPress={onClickHeader}
        role="menubar"
        tabIndex={0}
        data-testid="collapsible-bar-order-header-container"
      >
        <div className={styles.saleType}>
          <h3>Sale Type</h3>
          <p>{saleType}</p>
        </div>
        <div className={`${styles.header} ${styles.orderHeader}`}>
          <div className={styles.details}>
            <div>
              <h3>Items</h3>
              <p>{items}</p>
            </div>
            <div className={styles.total}>
              <h3>Total</h3>
              <p>{currency.format(orderTotal)}</p>
            </div>
            <div>
              <h3>Ship To</h3>
              <p className={styles.shipTo} data-tip={shipToTooltip} data-for="shipping">
                {`${firstName} ${lastName}`} <i className="fal fa-angle-down" />
              </p>
            </div>
          </div>
          <button
            className={styles.button}
            onClick={toggleOpen}
            type="button"
            data-testid="expand-collapse-btn"
          >
            <i className={icon} />
          </button>
        </div>
      </div>
      <ReactTooltip
        id="shipping"
        place="bottom"
        type="dark"
        effect="solid"
        className={styles.tooltip}
        html
      />
    </>
  );
};

export default OrderHeader;
